module.exports = __webpack_public_path__ + "img/smart_scan@2x.6cfc19d1.png";